import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {SimulationSession} from '../../data/SimulationSession';
import {ModelsDataProvider} from '../../data/ModelsDataProvider';
import {Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {AristoDialogComponent} from '../../aristo-dialog/aristo-dialog.component';

@Component({
  selector: 'app-step4-installation',
  templateUrl: './step4-installation.component.html',
  styleUrls: ['./step4-installation.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class Step4InstallationComponent implements OnInit {

  @Input() simulationSession!: SimulationSession;
  @Output() simulationSessionChange: EventEmitter<SimulationSession> = new EventEmitter<SimulationSession>();
  @Output() leftButton: EventEmitter<any> = new EventEmitter<any>();
  @Output() rightButton: EventEmitter<any> = new EventEmitter<any>();

  formatLabel(value: number) {
    return value + '€';
  }

  constructor(private modelsDataProvider: ModelsDataProvider, private router: Router , public dialog: MatDialog) {
  }

  ngOnInit(): void {
  }

  leftButtonClicked(){
    this.saveTVA();
    this.leftButton.emit();
  }

  rightButtonClicked(){
    if (this.isValid()) {
      this.saveTVA();
      this.router.navigate(['/numbersOverview']);
    }
  }

  saveTVA() {
    if (this.simulationSession.tva) {
      if (this.simulationSession.priceInstallationTrad && this.simulationSession.priceInstallationAriston && this.simulationSession.priceAriston) {

        this.simulationSession.priceTradWithoutInstallation = (this.simulationSession.priceTrad * (1 + this.simulationSession.tva / 100));

        this.simulationSession.priceTradWithInstallation = (this.simulationSession.priceTrad
          + this.simulationSession.priceInstallationTrad)
          * (1 + this.simulationSession.tva / 100);

        this.simulationSession.priceAristonWithoutInstallation = this.simulationSession.priceAriston * (1 + this.simulationSession.tva / 100);

        this.simulationSession.priceAristonWithInstallation = (this.simulationSession.priceAriston
          + this.simulationSession.priceInstallationAriston)
          * (1 + this.simulationSession.tva / 100);
      }

    }
    this.simulationSessionChange.emit(this.simulationSession);
  }

  isValid(): boolean {
    if (this.simulationSession.priceInstallationTrad && this.simulationSession.priceInstallationTrad > 0
      && this.simulationSession.priceInstallationAriston  && this.simulationSession.priceInstallationAriston > 0 ) {
      if (!this.simulationSession.tva) {
        this.dialog.open(AristoDialogComponent, { data: { dialogText: 'MESSAGES.ERRORS.TVA_ERROR'}});
        return false;
      }
      return true;
    }
    else {
      this.dialog.open(AristoDialogComponent, { data: { dialogText: 'MESSAGES.ERRORS.INSTALLATION_ERROR'}});
      return false;
    }
  }

}
